"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledMediaQuery = _interopRequireDefault(require("styled-media-query"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    flex-direction: row; \n    flex-wrap: wrap;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   padding: 0;\n    width: 100%; \n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var columnStyles = (0, _styledComponents.css)(["padding:1rem 2rem;width:34%;", ""], _styledMediaQuery["default"].lessThan('medium')(_templateObject()));

var Container = _styledComponents["default"].div.withConfig({
  displayName: "Vitos__Container",
  componentId: "sc-1vjpd3n-0"
})(["box-sizing:border-box;margin:2rem auto;max-width:100%;padding:1rem;width:1170px;p,li,a,button{font-size:1rem;}"]);

var Grid = _styledComponents["default"].div.withConfig({
  displayName: "Vitos__Grid",
  componentId: "sc-1vjpd3n-1"
})(["display:flex;flex-direction:row-reverse;", ""], _styledMediaQuery["default"].lessThan('medium')(_templateObject2()));

var Aside = _styledComponents["default"].aside.withConfig({
  displayName: "Vitos__Aside",
  componentId: "sc-1vjpd3n-2"
})(["", ";width:34%;"], columnStyles);

var Section = _styledComponents["default"].section.withConfig({
  displayName: "Vitos__Section",
  componentId: "sc-1vjpd3n-3"
})(["", ";width:66%;"], columnStyles);

var Vitos = function Vitos() {
  return /*#__PURE__*/_react["default"].createElement(Container, null, /*#__PURE__*/_react["default"].createElement(Grid, null, /*#__PURE__*/_react["default"].createElement(Section, null, /*#__PURE__*/_react["default"].createElement("h2", null, "Needs a landmark title"), /*#__PURE__*/_react["default"].createElement("p", null, "All aspects of our operations conform to the ISO 9001:2015 standard. We supply automotive rubber products which meet ASTM D2000 line call-outs, as well as the material specifications of major OEM\u2019s, including General Motors, Ford, Chrysler, Nissan, Mazda, BMW, Honda, Toyota, Volvo and more. In those cases where a new specification is required, we work with our partners to develop an appropriate solution."), /*#__PURE__*/_react["default"].createElement("p", null, "All aspects of our operations conform to the ISO 9001:2015 standard. We supply automotive rubber products which meet ASTM D2000 line call-outs, as well as the material specifications of major OEM\u2019s, including General Motors, Ford, Chrysler, Nissan, Mazda, BMW, Honda, Toyota, Volvo and more. In those cases where a new specification is required, we work with our partners to develop an appropriate solution.")), /*#__PURE__*/_react["default"].createElement(Aside, null, /*#__PURE__*/_react["default"].createElement("h3", null, "This goes after "), /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, "Option one"), /*#__PURE__*/_react["default"].createElement("li", null, "Option two"), /*#__PURE__*/_react["default"].createElement("li", null, "Option three")))));
};

var _default = Vitos;
exports["default"] = _default;